import React, { Component } from 'react';

// Import custom components
import EmbeddedWebview from '../components/EmbeddedWebview.js';

class ReportPage extends Component {
  render() {
    return (
      <div className="ReportPage container">
        <EmbeddedWebview src="https://docs.google.com/forms/d/e/1FAIpQLSeX7bcutDUpQAKBRCI4kEfRxDD0tZG_fb8j4y0dG6H4PhhHPg/viewform" />
      </div>
    )
  }
}

export default ReportPage;



// WEBPACK FOOTER //
// ./src/containers/ReportPage.js